export const isMobile = (exclusions = []) => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent;
    const isTouch = (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) || (typeof window !== 'undefined' && 'ontouchstart' in window);
    // Modern iPadOS identifies as Macintosh in userAgent with touch points > 1
    const isIpadOS = /Macintosh/i.test(ua) && isTouch;
    const isStandardMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

    const matched = isStandardMobile || isIpadOS;
    return matched && !exclusions.some(exclusion => ua.includes(exclusion) || (exclusion === 'iPad' && isIpadOS));
}

export const isPortrait = () => {
    return window.matchMedia("(orientation: portrait)").matches;
}

/**
 * Strips chords, tablatures, chord containers, section headers (e.g. [Intro], [Solo], [Refrão]),
 * and isolated chord tokens from lyric text to return clean readable plain lyrics preview.
 * @param {string} rawLyric
 * @param {number} [maxLen=140]
 * @returns {string}
 */
export const cleanLyricPreview = (rawLyric, maxLen = 140) => {
    if (!rawLyric || typeof rawLyric !== 'string') return '-';

    let text = rawLyric
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<span class="chord-[^"]*".*?>.*?<\/span>/gi, '')
        .replace(/<sup class="chord-[^"]*".*?>.*?<\/sup>/gi, '')
        .replace(/<[^>]+>/g, ' ');

    // Normalize newlines and process lines
    const lines = text.split(/\r?\n/);
    const cleanedLines = [];

    // Regex to test if a line is a tablature line (e.g. e|---, E|---, Solo violão:610 68 610, e|---2---, etc.)
    const tabRegex = /^([a-gA-G][b#]?\s*[:|]|solo\s*.*:|[0-9\s|-]{6,})/i;
    // Regex for standalone chords pattern: e.g. "Cm7 F Cm7 F", "G# A Bm", "Em D"
    const chordPattern = /^[A-G][b#]?(?:m|maj|min|dim|aug|sus|add|M)?[0-9]*(?:\/[A-G][b#]?)?$/;

    for (let line of lines) {
        let trimmed = line.trim();
        if (!trimmed) continue;

        // Skip tablature or solo notation lines
        if (tabRegex.test(trimmed)) continue;

        // Remove section markers like [Intro], [Refrão], [Verso 1], [Solo], (Intro), etc.
        trimmed = trimmed.replace(/\[\s*(intro|verso|refrão|refrao|chorus|verse|solo|ponte|bridge|outro|interlúdio|interludio|final)[^\]]*\]/gi, '');
        trimmed = trimmed.replace(/\(\s*(intro|verso|refrão|refrao|chorus|verse|solo|ponte|bridge|outro|interlúdio|interludio|final)[^)]*\)/gi, '');
        // Remove standalone chord bracket markers like [Cm7], [G#]
        trimmed = trimmed.replace(/\[\s*[A-G][b#]?[^\]]*\]/g, '');
        trimmed = trimmed.replace(/\[\([^)]*\)\]/g, '');

        trimmed = trimmed.trim();
        if (!trimmed) continue;

        // Check if all tokens in the line are just chords
        const tokens = trimmed.split(/\s+/);
        const nonChordTokens = tokens.filter(tok => !chordPattern.test(tok.replace(/[(),]/g, '')));
        if (tokens.length > 0 && nonChordTokens.length === 0) {
            // Entire line consists of chords
            continue;
        }

        // Remove isolated leading chords if followed by regular lyric words (e.g. "F Bless the Lord" -> "Bless the Lord")
        while (tokens.length > 1 && chordPattern.test(tokens[0].replace(/[(),]/g, ''))) {
            tokens.shift();
        }
        trimmed = tokens.join(' ').trim();

        if (trimmed) {
            cleanedLines.push(trimmed);
        }
    }

    const result = cleanedLines.join(' ').replace(/\s+/g, ' ').trim();
    if (!result) return '-';
    return result.length > maxLen ? result.slice(0, maxLen) + '...' : result;
};
